import { Component, Injector, OnInit } from '@angular/core';
import { EquipeService } from 'src/app/shared/api/equipe.service';
import { equipeResource } from '../equipe.resource';
import { AutocadastroService } from 'src/app/shared/api/autocadastro.service';
import { LicencasDisponiveisService } from 'src/app/shared/api/licencas/licencas-disponiveis.service';

@Component({
    selector: 'app-form-equipe',
    templateUrl: './form-equipe.component.html',
    styleUrls: ['./form-equipe.component.css'],
    providers: [LicencasDisponiveisService]
})
export class FormEquipeComponent implements OnInit {
    equipeResource = equipeResource;
    entidade!: any;
    showAutocadastro = false;

    licencasDisponiveisLiberarService!: LicencasDisponiveisService;

    constructor(
        public equipeService: EquipeService,
        public autocadastroService: AutocadastroService,
        public licencasDisponiveisService: LicencasDisponiveisService,
        private injector: Injector
    ) {}

    ngOnInit(): void {
        this.licencasDisponiveisLiberarService = this.criarInstanciaLicencasDisponiveis();
    }

    changeEntidadeOriginal(equipe: any) {
        this.autocadastroService.setBaseUrl(equipe[equipeResource.fieldPk]);
        this.licencasDisponiveisService.setBaseUrl({ equipe: equipe[equipeResource.fieldPk] });
        this.licencasDisponiveisLiberarService.setBaseUrl({ equipe: null });
        this.showAutocadastro = true;
    }

    private criarInstanciaLicencasDisponiveis(): LicencasDisponiveisService {
        return Injector.create({
            providers: [
                { provide: LicencasDisponiveisService, useClass: LicencasDisponiveisService }
            ],
            parent: this.injector
        }).get(LicencasDisponiveisService);
    }
}
